<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return { }
  },
  computed: {
    cachedViews() {
      return ['Stores']
    },
    key() {
      return this.$route.path
    }
  },
  methods: { }
}
</script>

<style lang="scss" scoped>
.app-main {
  position: relative;
  // width: 100%;
  // max-width: 1200px;
  min-height: calc(100vh - #{$headerHeight} - #{$footerHeight});
  overflow: hidden;
}
</style>

